export const BATTLEYE_R2_NEW_EN_USE_OSS = process.env.NODE_ENV === "production";

const LOCAL_PREFIX = `${process.env.BASE_URL}detail/battleye-r2-new-en/`;
const SHARED_LOCAL_PREFIX = `${process.env.BASE_URL}detail/battleye-r2-new/`;
const OSS_SUFFIX = "battleye_r2_new_en/";
const SHARED_OSS_SUFFIX = "battleye_r2_new/";

interface ResolveAssetOptions {
  assetPath: string;
  oss: string;
  useOss?: boolean;
}

export const resolveBattleyeR2NewEnAsset = ({
  assetPath,
  oss,
  useOss = BATTLEYE_R2_NEW_EN_USE_OSS
}: ResolveAssetOptions): string => {
  if (!useOss) {
    return assetPath;
  }

  if (assetPath.startsWith(LOCAL_PREFIX)) {
    return assetPath.replace(LOCAL_PREFIX, `${oss}${OSS_SUFFIX}`);
  }

  if (assetPath.startsWith(SHARED_LOCAL_PREFIX)) {
    return assetPath.replace(SHARED_LOCAL_PREFIX, `${oss}${SHARED_OSS_SUFFIX}`);
  }

  return assetPath;
};
